import React, {useRef, useEffect} from 'react';
import mainStyles from 'components/homeParallax/HomeParallax.module.scss';
import styles from './MacroPage.module.scss';
import panelStyles from "components/homePanels/Panels.module.scss";
import layerStyles from "./heroLayers/Layers.module.scss";
import {buttonClick, isElementInViewport} from "utils/Helpers";
import {pageData} from './MacroPage.data';
import Quote from "./quote/Quote";
import Gallery from "./gallery/Gallery";
import Video from "./video/Video";
import Content from "./content/Content";
import Products from "./products/Products";
import ScrollEvent from "utils/ScrollEvent";
import MidGround from "./heroLayers/MidGround";
import BonusGround from "./heroLayers/BonusGround";
import ExploreSectionDown from "components/exploreSectionDown/ExploreSectionDown";
import MouseMove from "utils/MouseMove";
import PanelAnimations from "utils/PanelAnimations"
import ImageWrapper from "components/imageWrapper/ImageWrapper";
import ExtraBackGround from "components/homePanels/f-i_macroPage/heroLayers/ExtraBackGround";
import BackGround from "components/homePanels/f-i_macroPage/heroLayers/BackGround";
import {gsap} from 'gsap';
import HeaderLogo from "components/headerLogo/HeaderLogo";
import Tilt from "utils/Tilt";
import {useSelector} from "react-redux";
import {browserDetect} from "utils/Device";
import Signature from "components/homePanels/f-i_macroPage/signature/Signature";

const MacroPage = (props) => {

    const accessible = useSelector(state => state.accessible);
    const windowData = useSelector(state => state.window);
    const macro = props.macro.toLowerCase();
    const hero = useRef();
    const foreGround = useRef();
    const bonusGround = useRef();
    const midGround = useRef();
    const extraBackGround = useRef();
    const backGround = useRef();
    const fixedStage = useRef();
    const spacer = useRef();
    const autoComplete = useRef(false);

    const nextPanel = useRef()
    const content = useRef();
    const dark = (props.macro === 'Deadmau5' || props.macro === 'Brooke');
    const altBg = props.macro === 'Deadmau5' ? '_3' : '';
    const bgSet = {
        400: `https://msobd-storage.azureedge.net/images/profile_${props.macro.toLowerCase()}/backGroundx400${altBg}.jpg`,
        800: `https://msobd-storage.azureedge.net/images/profile_${props.macro.toLowerCase()}/backGroundx800${altBg}.jpg`,
        1350: `https://msobd-storage.azureedge.net/images/profile_${props.macro.toLowerCase()}/backGroundx1350${altBg}.jpg`,
        default: `https://msobd-storage.azureedge.net/images/profile_${props.macro.toLowerCase()}/backGround${altBg}.jpg`
    }

    useEffect(()=>{
        fixedStage.current.scrollTop = 0;
    },[accessible.exploring])

    /** firefox remembers scroll position, reset on the way out the door **/
    window.addEventListener('beforeunload', ()=>{
        fixedStage.current.scrollTop = 0
    })

    /** on load screen reader focus on main image **/
    useEffect(()=>{
        if(props.status === 'active' && accessible.siteEntered) {
            setTimeout(()=>{
                if(foreGround.current)foreGround.current.firstChild.focus();
            }, 1000)

        }
    }, [props.status, accessible.siteEntered])

    function nextCheck(){

        /** if hero panel is scrolled back to **/
        if(accessible.exploring && hero.current && (hero.current.getBoundingClientRect().top - hero.current.offsetParent.getBoundingClientRect().top) > -50){
            props.onEnd(props.macro.toLowerCase());
        }

        /** if next panel is scrolled into **/
        if(accessible.exploring && nextPanel.current && isElementInViewport(spacer.current, true)){

            autoComplete.current = true;

            gsap.to(fixedStage.current, {duration: 0.5, scrollTo: spacer.current.offsetTop, onComplete: ()=>{
                if(autoComplete.current){
                    autoComplete.current = false;
                    fixedStage.current.scrollTop = 0;
                    props.onEnd(pageData[props.macro].nextPanel.toLowerCase(), true);
                }
            }} );

        }

    }


    function getContentBonusLayers(){
        if(macro === 'brooke'){

            return(
                <>
                    <div aria-hidden={true} className={`${layerStyles.brooke_leaves} ${layerStyles.brooke_contentBgLeaves}`}/>
                    <div aria-hidden={true} className={`${layerStyles.brooke_filmBgLeft} ${layerStyles.brooke_filmBgContent}`}/>
                    <div aria-hidden={true} className={`${layerStyles.brooke_filmBgRight} ${layerStyles.brooke_filmBgContent}`}/>
                </>
            )
        }
        if(macro === 'deadmau5'){

            return(
                <>
                    <div aria-hidden={true} className={`${layerStyles.deadmau5_wavesLeft}  ${layerStyles.deadmau5_waves}`}/>
                    <div aria-hidden={true} className={`${layerStyles.deadmau5_wavesRight}  ${layerStyles.deadmau5_waves}`}/>
                </>
            )
        }
    }

    function getContent(){

        if(accessible.exploring && props.status === 'active'){

            let bgKey = 'default';
            let set = {...bgSet}
            let sizeFound = false;
            delete set['default'];

            for (let [key] of Object.entries(set)) {
                if(!sizeFound && windowData.width < parseInt(key)) {
                    sizeFound = true;
                    bgKey = key;
                }
            }

            let h = fixedStage.current.getBoundingClientRect().height;

            let bgBaseline = ((h *1.25)-h) / 2;

            let browser = browserDetect();
            let top = browser.mobile && window.width < 767 ? (
                browser.name === 'Safari' ? `22%` : `20%` // depends on ui elements
            ) :  `${(bgBaseline) - 6}px`

            let bgStyle = null;
            if(bgSet[bgKey]){
                bgStyle = props.macro !== 'Deadmau5' ? {
                    backgroundImage: `url(${bgSet[bgKey]})`,
                    backgroundPosition: `center ${top}`
                } : {backgroundColor: '#000'};
            }

            return (
                <>

                    <div ref={content} className={styles.sectionBg} style={bgStyle}>

                        <Quote title={pageData[props.macro].title} quote={pageData[props.macro].quote} dark={dark} macro={macro} scroller={fixedStage.current}/>

                        <Gallery galleryLabel={pageData[props.macro].galleryLabel} title={pageData[props.macro].title} images={pageData[props.macro].images} macro={macro} scroller={fixedStage.current}/>

                        <Content content={pageData[props.macro].content} macro={macro} scroller={fixedStage.current}/>

                        {/** We don't want to load these videos unless they have decided to explore this content **/}
                        {accessible.exploring && <Video title={pageData[props.macro].title} video={pageData[props.macro].video} macro={macro}/>}

                        <Products products={pageData[props.macro].product} macro={macro} scroller={fixedStage.current}/>

                        {getContentBonusLayers()}

                    </div>

                    <div ref={spacer} className={styles.nextSpacer}/>

                    <div ref={nextPanel} className={`${styles.nextPanel}`}></div>

                    <span className={mainStyles.accessibleContent} tabIndex={accessible.siteEntered ? 0 : null} role={'button'} aria-label={'Navigate to previous section'} onKeyDown={buttonClick} onClick={()=>props.menuClick(pageData[props.macro].previousPanel.toLowerCase())}/>
                    <span className={mainStyles.accessibleContent} tabIndex={accessible.siteEntered ? 0 : null} role={'button'} aria-label={'Navigate to next section'} onKeyDown={buttonClick} onClick={()=>props.menuClick(pageData[props.macro].nextPanel.toLowerCase())}/>

                    <ScrollEvent target={fixedStage.current} scroll={nextCheck} debounce={0} mobileCheck={true}/>

                </>
            )
        }
    }

    function getOriginalBy(){
        return <Signature status={props.status} className={`signature ${panelStyles.originalBy} ${panelStyles['originalBy_'+macro]}`} aria-label={`Original by ${pageData[props.macro].title} custom signature`}/>
    }

    function textColor(){
        return dark ? styles.whiteText : styles.blackText
    }

    function checkBonusGround(){
        return (
            <div aria-hidden={true} ref={bonusGround} className={`${panelStyles.bonusGround} ${accessible.exploring ? panelStyles.lockedBg : ''}`}>
                <BonusGround macro={macro}/>
            </div>
        )
    }

    function checkExtraBackGround(){
        if(macro === 'martellus'){
            return (
                <div aria-hidden={true} ref={extraBackGround} className={`${panelStyles.extraBackGround}`}>
                    <ExtraBackGround macro={macro}/>
                </div>
            )
        }
    }

    return (
        <div data-id={macro} data-status={props.status} ref={fixedStage} className={`${panelStyles.fixedStage} ${accessible.exploring ? panelStyles.panelLocked : ''} ${textColor()}`} style={{zIndex: props.zIndex}}>

            {accessible.exploring && <HeaderLogo menuClick={()=>props.menuClick('introText')} static={true}/>}

            <div ref={hero} className={`${panelStyles.hero} ${panelStyles.fullSize} `}>
                <div ref={foreGround}  className={`${panelStyles.foreGround}`}>
                    <ImageWrapper tabIndex={-1} className={panelStyles.logo} set={{default:`https://msobd-storage.azureedge.net/images/profile_${macro}/logo.png`}} alt={`${pageData[props.macro].title} and Surface Four Squares`}/>
                    <div className={panelStyles.info}>
                        {getOriginalBy()}
                        <ExploreSectionDown dark={dark} status={props.status} macro={props.macro}
                                            content={content} cta={pageData[props.macro].cta}/>

                    </div>
                </div>

            </div>

            {checkBonusGround()}

            <div aria-hidden={true} ref={midGround} className={`${panelStyles.midGround}`}>
                <MidGround macro={macro}/>
            </div>

            {checkExtraBackGround()}


            <BackGround aria-hidden={true} ref={backGround} set={bgSet} cover={props.macro === 'Deadmau5'}/>


            {getContent()}

            {!accessible.exploring && (
                <>
                    <span className={mainStyles.accessibleContent} tabIndex={accessible.siteEntered ? 0 : null} role={'button'} aria-label={'Navigate to previous section'} onKeyDown={buttonClick} onClick={()=>props.menuClick(pageData[props.macro].previousPanel.toLowerCase())}/>
                    <span className={mainStyles.accessibleContent} tabIndex={accessible.siteEntered ? 0 : null} role={'button'} aria-label={'Navigate to next section'} onKeyDown={buttonClick} onClick={()=>props.menuClick(pageData[props.macro].nextPanel.toLowerCase())}/>
                </>
            )}

            <PanelAnimations skipAnimation={props.skipAnimation}
                             fixedStage={fixedStage} backGround={backGround} extraBackGround={extraBackGround}
                             midGround={midGround} bonusGround={bonusGround} foreGround={foreGround} panel={macro}/>
            <MouseMove status={props.status} backGround={backGround} extraBackGround={extraBackGround}
                       midGround={midGround} bonusGround={bonusGround}/>
            <Tilt backGround={backGround} extraBackGround={extraBackGround} midGround={midGround} bonusGround={bonusGround}/>

        </div>
    )
};

export default MacroPage